
import { listen } from './lib/_listening_time.js';

let $html 		= document.documentElement;
export let home = {
	init: function(){
		let $body = document.querySelector("body");
		home.nav();
		if( $body.classList.contains("login") && $body.classList.contains("entried") ){
			listen.getMyData();
		}
	},
	nav: function(){
		let $login = document.querySelector("#start a.btn_login");
		if( $html.classList.contains("pc") ){
			$login.removeEventListener("click", home.openLoginModal, false);
			$login.addEventListener("click", home.openLoginModal, false);
		}else{
			$login.removeEventListener("touchstart", home.openLoginModal, false);
			$login.addEventListener("touchstart", home.openLoginModal, false);
		}
		let $closeLogin = document.querySelector("a#close_login");
		if( $html.classList.contains("pc") ){
			$closeLogin.removeEventListener("click", home.closeLoginModal, false);
			$closeLogin.addEventListener("click", home.closeLoginModal, false);
		}else{
			$closeLogin.removeEventListener("touchstart", home.closeLoginModal, false);
			$closeLogin.addEventListener("touchstart", home.closeLoginModal, false);
		}
		
		let $help = document.querySelector("a[data-help]");
		if( $html.classList.contains("pc") ){
			$help.removeEventListener("click", home.openHelpModal, false);
			$help.addEventListener("click", home.openHelpModal, false);
		}else{
			$help.removeEventListener("touchstart", home.openHelpModal, false);
			$help.addEventListener("touchstart", home.openHelpModal, false);
		}
		let $closeHelps = document.querySelectorAll("[data-close-help]");
		$closeHelps.forEach( ($h) => {
			$h.removeEventListener("click", home.closeHelpModal, false);
			$h.addEventListener("click", home.closeHelpModal, false);
		});
		let $updateBtn = document.querySelector("[data-update]");
		$updateBtn.removeEventListener("click", home.reload, false);
		$updateBtn.addEventListener("click", home.reload, false);
		//Comment ---------
		let $closeComment = document.querySelector("a.close_comment");
		if( $html.classList.contains("pc") ){
			$closeComment.removeEventListener("click", home.closeComment, false);
			$closeComment.addEventListener("click", home.closeComment, false);
		}else{
			$closeComment.removeEventListener("touchstart", home.closeComment, false);
			$closeComment.addEventListener("touchstart", home.closeComment, false);
		}
	},
	openLoginModal: function(){
		if( !$html.classList.contains("show_login") ){
			$html.classList.add("show_login");
		}
	},
	closeLoginModal: function(){
		if( $html.classList.contains("show_login") ){
			$html.classList.remove("show_login");
		}
	},
	openHelpModal: function(){
		if( !$html.classList.contains("show_help") ){
			$html.classList.add("show_help");
		}
	},
	closeHelpModal: function(){
		if( $html.classList.contains("show_help") ){
			$html.classList.remove("show_help");
		}
	},
	reload: function(){
		window.location.reload();
	},
	closeComment: function(){
		let $comment = document.querySelector(".block_comment");
		if( !$comment.classList.contains("disable") ){
			$comment.classList.add("disable");
		}
	}
}